// @flow

import { call, delay, put, race, take, takeLatest } from 'redux-saga/effects';
import { fetchJSON } from '../../helpers/api';
import {
    diagnosticsFailed,
    diagnosticsLatestMissing,
    diagnosticsLoaded,
    diagnosticsStarted,
} from './actions';

const isActive = (report) => report && ['queued', 'running'].includes(report.status);

function* pollDiagnostic(domainId, requestId) {
    while (true) {
        const result = yield race({
            tick: delay(2000),
            stop: take('DIAGNOSTICS_STOP'),
        });
        if (result.stop) return;

        try {
            const report = yield call(fetchJSON, `/domains/${domainId}/diagnostics/${requestId}`, { method: 'GET' });
            yield put(diagnosticsLoaded(domainId, report));
            if (!isActive(report)) return;
        } catch (error) {
            yield put(diagnosticsFailed(domainId, error));
            return;
        }
    }
}

function* startDiagnostic({ payload: { domainId } }) {
    try {
        const report = yield call(fetchJSON, `/domains/${domainId}/diagnostics`, { method: 'POST' });
        yield put(diagnosticsStarted(domainId, report));
        if (isActive(report)) yield* pollDiagnostic(domainId, report.request);
    } catch (error) {
        yield put(diagnosticsFailed(domainId, error));
    }
}

function* loadLatestDiagnostic({ payload: { domainId } }) {
    try {
        const report = yield call(fetchJSON, `/domains/${domainId}/diagnostics/latest`, { method: 'GET' });
        yield put(diagnosticsLoaded(domainId, report));
        if (isActive(report)) yield* pollDiagnostic(domainId, report.request);
    } catch (error) {
        if (error.status_code === 404) {
            yield put(diagnosticsLatestMissing(domainId));
        } else {
            yield put(diagnosticsFailed(domainId, error));
        }
    }
}

export function* watchDiagnosticsStart() {
    yield takeLatest('DIAGNOSTICS_START', startDiagnostic);
}

export function* watchDiagnosticsLatestLoad() {
    yield takeLatest('DIAGNOSTICS_LATEST_LOAD', loadLatestDiagnostic);
}

export default function* DiagnosticsSaga() {
    yield takeLatest('DIAGNOSTICS_START', startDiagnostic);
    yield takeLatest('DIAGNOSTICS_LATEST_LOAD', loadLatestDiagnostic);
}
